import { StyledInput } from './Input.styles';

const Input = ({ small, ...otherProps }) => {
  return <StyledInput small={small ? 1 : 0} {...otherProps} />;
};
export default Input;
